import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore';
import { bankTypes, IAvailablePromoCodes } from '@Store/slices/customer/customer.types.ts';
import { InstitutionIds } from '@Types/types.ts';

export interface ICreateLeadPayload {
  firstName?: string;
  lastName?: string;
  email: string;
  password: string;
}

export interface ICreateLeadResponse {
  accessToken: string;
  externalId: string;
  isNonUsSupported: boolean;
  isPartner: boolean;
  moreData: boolean;
  requireAuthentication: boolean;
  availablePromoCodes: IAvailablePromoCodes;
  bank: bankTypes;
}

export interface UpdateCustomerNamePayload {
  firstName: string;
  lastName: string;
}

export const createPartnerLead = async (payload: ICreateLeadPayload) => {
  const { adSource, referralCode } = useBoundStore.getState().onboardingSlice;
  const { customerId } = useBoundStore.getState().customer;

  const { data } = await HttpService.put(`v3/secureonboarding/partner/user/${customerId}`, {
    firstName: payload.firstName || null,
    lastName: payload.lastName || null,
    email: payload.email,
    password: payload.password,
    bankCode: InstitutionIds.SUNRISE,
    fingerprint: (window as unknown as { fpId: string }).fpId,
    referralCode,
    adSource,
    abTestNames: [],
  });
  return data as ICreateLeadResponse;
};

export const fetchCustomerData = async () => {
  const { customerId } = useBoundStore.getState().customer;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  const path = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}`
    : `v3/secureonboarding/user/${customerId}`;
  const { data } = await HttpService.get(path);

  return data;
};

export const updateCustomerName = async (payload: UpdateCustomerNamePayload) => {
  const { customerId } = useBoundStore.getState().customer;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  const path = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/name`
    : `v3/secureonboarding/user/${customerId}/name`;

  const { data } = await HttpService.post(path, {
    ...payload,
  });
  return data;
};
